<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="disabled" [multiple]="multiple"
           [placeholder]="'hx.dictionary-select.placeholder.selectExpense' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op.code">{{ op.title | uiLabel }}</ng-option>
</ng-select>
